<!-- <div class="custombg fixed-top">
  <nav *ngIf="isAdd" aria-label="breadcrumb" class="breadcrumb-container">
    <ol class="breadcrumb mb-0">
      <li class="breadcrumb-item" aria-current="page"(click)= "goToHome()"style="cursor:pointer">Home</li>
      <li class="breadcrumb-item " style="cursor:pointer"(click)= "goToSearch()">KMS Portal</li>
      <li class="breadcrumb-item" style="cursor:pointer"aria-current="page"(click)= "goToProjectContent()">Project Content</li>
      <li class="breadcrumb-item " aria-current="page">Add Project</li>
    </ol>
  </nav>
  <nav *ngIf="isEdit &&!isView" aria-label="breadcrumb" class="breadcrumb-container">
    <ol class="breadcrumb mb-0">
      <li class="breadcrumb-item" aria-current="page"(click)= "goToHome()"style="cursor:pointer">Home</li>
      <li class="breadcrumb-item " style="cursor:pointer"(click)= "goToSearch()">KMS Portal</li>
      <li class="breadcrumb-item " style="cursor:pointer"aria-current="page"(click)="goBack(project.contentType)">{{project.contentType}}</li>
      <li class="breadcrumb-item " aria-current="page">Edit Project</li>
    </ol>
  </nav>
  <nav *ngIf="isView" aria-label="breadcrumb" class="breadcrumb-container">
    <ol class="breadcrumb mb-0">
      <li class="breadcrumb-item" aria-current="page"(click)= "goToHome()"style="cursor:pointer">Home</li>
      <li class="breadcrumb-item " style="cursor:pointer"(click)= "goToSearch()">KMS Portal</li>
      <li class="breadcrumb-item " style="cursor:pointer"aria-current="page"(click)="goToProjectContent()">Project Content</li>
      <li class="breadcrumb-item " aria-current="page">View Project</li>
    </ol>
  </nav>
</div> -->

<div class="wrapper">
  <div class="modal-container">
    <div class="row">
      <div class="col-12 col-md-12 col-lg-12 col-xl-12 p-2 mt-2 mb-4 ">
        <div class="card">
          <!---Title-->
          <div class="row d-flex p-3 m-0 border-bottom">
            <div class="heading_1  mr-auto">{{title}}</div>
          </div>
          <form class="form" [formGroup]="formData">
            <!---row loop-->
            <div class="row p-3 m-0 border-bottom">
              <div class="col-12 p-0 mb-2">
                <div class="row pb-2">
                  <div class="col-12 col-md-4 col-lg-4 ">
                    <div class="pr-2">
                      <div><span class="secondaryInfo">Deck Name *</span></div>
                      <input type="text" class="form-control" [placeholder]="isView? '' : 'Enter Deck Name'"
                        formControlName="projectName">
                        <div *ngIf=" formData.get('projectName').touched || flag">
                          <mat-error class="errorFont"
                          *ngIf="formData.get('projectName').errors?.required ">
                          Deck Name is Required</mat-error>
                          <mat-error class="errorFont" *ngIf="formData.get('projectName').hasError('pattern')">
                            Only letters and spaces are allowed for Deck Name
                          </mat-error></div>
                    </div>
                  </div>
                  <div class="col-12 col-md-4 col-lg-4 ">
                    <div class="pr-2"><span class="secondaryInfo">Select Content Type *</span></div>
                    <select class="form-control" formControlName="contentType">
                      <option value="" selected disabled hidden>Select</option>
                      <option *ngFor="let type of contentTypes" [value]="type">{{type}}</option>
                    </select>
                    <div *ngIf=" formData.get('contentType').touched || flag">
                      <mat-error class="errorFont"
                      *ngIf="formData.get('contentType').errors?.required ">
                      Content Type is Required</mat-error></div>
                  </div>
                  <div class="col-12 col-md-4 col-lg-4 ">
                    <div class="pr-2">
                      <div>
                        <span class="secondaryInfo">Delivery Organization *</span></div>
                      <select class="form-control" formControlName="companyName">
                        <option *ngFor="let deliveryOrganization of deliveryOrganizations"
                          [value]="deliveryOrganization.name">
                          {{deliveryOrganization.name}}</option>
                      </select>
                      <div *ngIf=" formData.get('companyName').touched || flag">
                        <mat-error class="errorFont"
                        *ngIf="formData.get('companyName').errors?.required ">
                        Delivery Organization is Required</mat-error></div>
                    </div>
                  </div>
                </div>
                <div class="row pb-2">
                  <div class="col-12 col-lg-4 col-md-4">
                    <div class="pr-2">
                      <div><span class="secondaryInfo">Description *</span></div>
                      <input type="text" class="form-control" [placeholder]="isView ? '' : 'Enter Description'"
                        formControlName="description"  minlength="30" maxlength="150"></div>
                    <div *ngIf="(formData.get('description').invalid && formData.get('description').touched && formData.get('description').errors)||flag">

                      <mat-error class="errorFont" *ngIf="formData.get('description').errors?.required">Description is required</mat-error>
                      <mat-error class="errorFont" *ngIf="formData.get('description').value.length<30&&!formData.get('description').hasError('required')" >Min length is 30</mat-error>

                      <mat-error class="errorFont" *ngIf="isDescription" >InValid Format</mat-error>
                    </div> 
                  </div>
                  <div class="col-12 col-lg-4 col-md-4">
                    <div class="pr-2">
                      <div><span class="secondaryInfo">Purpose of usage *</span></div>
                      <input type="text" class="form-control" [placeholder]="isView ? '' : 'Enter purpose of usage'"
                        formControlName="purposeOfUsage">
                        <div *ngIf=" formData.get('purposeOfUsage').touched || flag">
                          <mat-error class="errorFont"
                          *ngIf="formData.get('purposeOfUsage').errors?.required ">Purpose of usage is Required</mat-error>
                          <mat-error class="errorFont" *ngIf="isPurpose" >InValid Format</mat-error>

                    </div>
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 col-md-4">
                    <div><span class="secondaryInfo">Client Logo</span></div>
                    <div class="custom-file pr-2">
                      <input type="file" class="custom-file-input" accept=".png,.jpg,.jpeg,.svg"  formControlName="logo"
                        (change)="handleFileInput($event.target.files , attachmentTypes.clientLogo)" id="logoFile">
                      <label class="custom-file-label" for="logoFile">{{getFile(attachmentTypes.clientLogo)}}</label>
                      <ng-template #showEmpty>
                        <label class="custom-file-label" for="logoFile">Choose logo</label>
                      </ng-template>
                      <div *ngIf=" formData.get('logo').touched || flag && this.mode==='add'" >
                      <mat-error class="errorFont"
                          *ngIf="formData.get('logo').errors?.required ">
                          Client Logo is Required</mat-error>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="row pb-2">
                  <div class="col-12 col-md-4 col-lg-4">
                    <div class="pr-2">
                      <div><span class="secondaryInfo">Contact Person *</span></div>
                      <input type="text" class="form-control" (keyup)="Onchange()" placeholder="Enter Contact Person"
                      maxlength="40"  (input)="getFilteredValues($event.target.value)" (onfocus)="getFilteredValues('')"
                      [matAutocomplete]="partner" formControlName="contactPerson">
                    <mat-autocomplete autoActiveFirstOption #partner="matAutocomplete"
                    (optionSelected)='setCurrentEmployee($event.option.id)'>
                    <mat-option *ngFor="let partner of filteredValues" [id]="partner.employeeId" [value]="partner.name">
                      {{partner.name}} ({{partner.employeeId}})
                    </mat-option>
                  </mat-autocomplete>
                  <div *ngIf="formData.get('contactPerson').touched || flag">
                    <mat-error class="errorFont"
                      *ngIf="formData.get('contactPerson').errors?.required">
                      Contact Person is Required</mat-error>
                      <mat-error class="errorFont" *ngIf="formData.get('contactPerson').hasError('pattern')">
                        Invalid Format
                      </mat-error>
                    </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-4 col-lg-4 d-flex mt-4 mb-2">
                    <div class="pr-2 mt-auto my-2">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" formControlName="restrictedContent" class="custom-control-input" id="customCheck1">
                        <label class="custom-control-label w-100 cursor-pointer" for="customCheck1">Restricted Content</label>
                      </div>
                    </div>
                    <div class="pr-2 mt-auto my-2 ml-2 ">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" [checked]="changesAllowedChecked" (change)="toggleChangesAllowed()" class="custom-control-input" id="customCheck2">
                        <label class="custom-control-label w-100" for="customCheck2">Changes Allowed</label>
                      </div>
                    </div>
                  </div>                  
                  <div class="col-12 col-md-4 col-lg-4">
                    <div class="pr-2" [ngClass]="{'ppt-control':isView}">
                      <div *ngIf="!isView"><span class="secondaryInfo">Select Presentation
                        </span></div>
                      <div *ngIf="!isView " class="custom-file pr-2">
                        <input type="file" class="custom-file-input" accept=".pptx" formControlName="ppt"
                          (change)="handleFileInput($event.target.files , attachmentTypes.ppt)" id="logoFile">
                        <label class="custom-file-label" for="logoFile">{{getFile(attachmentTypes.ppt)}}</label>
                        <ng-template #showEmpty>
                          <label class="custom-file-label" for="logoFile">Choose file</label>
                        </ng-template>
                      </div>
                      <div *ngIf="isView && project.fileURL != null">
                        <div class="pptLink" (click)="viewFile(project.fileURL)"> View Presentation </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="row pt-2">

                  <div class="col-12 ">
                    <div class="pr-2">
                      <div><span class="secondaryInfo">Tags(csv) *</span></div>
                      <textarea rows="4" cols="50" class="form-control" formControlName="tags"
                        [placeholder]="isView ? '' : 'Enter Tags'">
                      </textarea>
                      <div *ngIf=" formData.get('tags').touched || flag">
                        <mat-error class="errorFont"
                        *ngIf="formData.get('tags').errors?.required">
                        Tags is Required</mat-error>
                        <mat-error class="errorFont"
                        *ngIf="isTag">
                        Invalid Format </mat-error>
                       
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12 my-3"
                  *ngIf="project && project.notes && projectType == 'history' && permissions.canViewNotes">
                  <div class="list-group">
                    <a class="list-group-item list-group-item-action flex-column align-items-start headerColor">
                      <div class="d-flex w-100 justify-content-between">
                        <h5 class="mb-1">Notes <span>({{project.notes.length}})</span></h5>
                      </div>
                    </a>
                    <a class="list-group-item list-group-item-action flex-column align-items-start"
                      *ngFor="let note of project.notes">
                      <div class="d-flex w-100 justify-content-between">
                        <h6 class="mb-1">{{note.createdBy}}</h6>
                        <small class="text-muted">{{note.duration}} ago</small>
                      </div>
                      <p class="mb-1">{{note.description}}</p>
                    </a>
                  </div>
                </div>

                <div class="col-12 d-flex p-0 mt-4 justify-content-center">

                </div>


                <div class="col-12 d-flex p-0 justify-content-center">
                  <div class="buttons_column align-self-center  p-0" style="margin-left: auto;"
                    *ngIf="isPending && permissions.canApproveProject;else showApproved">
                    <button type="button" class="btn btn-custom_primary ml-2 mr-2 color-orange-app " style="margin-left: auto;" id="inv_setup_save"
                      data-backdrop="static" data-keyboard="false" (click)="showCommentsDialog(true)">Approve</button>
                    <button type="button" class="btn btn-custom_primary ml-2 mr-2 color-red" id="inv_setup_save"
                      data-backdrop="static" data-keyboard="false" (click)="showCommentsDialog(false)">Reject </button>
                    <button type="button" class="btn btn-custom_primary ml-2 mr-2 " id="inv_setup_save"
                      data-backdrop="static" data-keyboard="false" (click)="cancel()">Close
                    </button>
                  </div>

                  <ng-template #showApproved>
                    <div class="buttons_column p-0" style="margin-left: auto; margin-top: 1rem;">
                      <button type="button" *ngIf="!isView" class="btn btn-custom_primary ml-2 mr-2 color-orange "
                        id="inv_setup_save" data-backdrop="static" data-keyboard="false" 
                        (click)="saveData()">Submit</button>
                      <button type="button" class="btn btn-custom_primary ml-2 mr-2 " id="inv_setup_cancel"
                        data-backdrop="static" data-keyboard="false"
                        (click)="cancel()">{{isView ? 'Close': 'Cancel'}}</button>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>